export default __webpack_public_path__ + "static/media/apple.02dbbad9.jpg";